import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import PlayScene from '../scenes/PlayScene';

export default class QuestionDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {PlayScene} scene 
   * @param {*} x 
   * @param {*} y 
   */
  constructor(scene, x, y) {
    super(scene, x, y);
    this.delegate = scene;
    this.setup();
  };

  setup () {
    this.tiedToPlatform = true;
    this.displayedQuestionData = null;

    this.bgContainer = this.scene.add.container();
    this.add(this.bgContainer);
    this.bg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._QuestionBg, this.bgContainer).setOrigin(0);
    this.txtQuestion = this.scene.add.bitmapText(this.bg.width / 2, this.bg.height / 2, 'questionFont', 'How many } are there', 50, 1).setOrigin(.5)
      .setCenterAlign();
    this.bgContainer.add(this.txtQuestion);
    this.txtQuestion.maxWidth = this.bg * 0.4;

    const qboxInfo = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._question_box, this).setVisible(false)
      .setOrigin(0);
    this.answerGroup = this.scene.add.container(0, 0);
    this.showCountGroup = this.scene.add.container(0, 0);
    this.bgContainer.add(this.showCountGroup);
    this.iconDisplays = [];
    let iconDisplay = null;

    for (let i = 0; i < 10; i++) {
      iconDisplay = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._bit, this.showCountGroup).setOrigin(0);
      this.iconDisplays.push(iconDisplay);
    }

    Phaser.Actions.GridAlign(this.iconDisplays, { width: -1, height: 2, cellWidth: iconDisplay.width * 1.5, cellHeight: iconDisplay.height * 1.5, position: Phaser.Display.Align.CENTER });
    this.showCountGroup.x = this.bg.width / 2 - this.showCountGroup.width / 2;
    this.showCountGroup.y = this.bg.y + this.bg.height - this.showCountGroup.height * 0.25;

    this.choiceDisplays = [];
    for (let i = 0; i < 4; i++) {
      const c = this.scene.add.container();
      const box = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._question_box, c).setOrigin(0);
      const bounds = c.getBounds();
      const b = this.scene.add.bitmapText(bounds.centerX - 2,bounds.centerY, 'choiceFont', '22', 72).setOrigin(0.5);
      c.add(b);

      c.displayText = b;
      c.box = box;

      this.answerGroup.add(c);
      this.choiceDisplays.push(c);

      box.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onChoiceClick(c));
    }
    this.add(this.answerGroup);
    const padding = 52;
    Phaser.Actions.GridAlign(this.answerGroup.getAll(), { width: 4, height: 1, cellWidth: qboxInfo.width + padding, cellHeight: qboxInfo.height, position: Phaser.Display.Align.CENTER });

    this.answerGroup.x = this.scene.scale.width / 2 - this.answerGroup.getBounds().width / 2;
    this.answerGroup.y = this.bg.y + this.bg.height + 170;

    this.feedbackIcon = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._AnswerFeedback_Incorrect, this);
    this.feedbackIcon.x = this.choiceDisplays[3].x + this.answerGroup.x + this.choiceDisplays[3].getBounds().width / 2;
    this.feedbackIcon.y = this.answerGroup.y - this.choiceDisplays[3].getBounds().height / 2;

    this.beenAnswered = false;
  };

  /**
   * 
   * @param {Phaser.GameObjects.Image} sprite 
   * @returns 
   */
  onChoiceClick(sprite) {
    if (this.beenAnswered) return;
    this.beenAnswered = true;
    const index = this.choiceDisplays.indexOf(sprite);
    this.selectedWasCorrect = false;
    this.selectedIndex = index;

    if (index === this.displayedQuestionData.answerIndex) {
      this.feedbackIcon.setFrame('AnswerFeedback_Correct');
      this.selectedWasCorrect = true;
    }
    else {
      this.feedbackIcon.setFrame('AnswerFeedback_Incorrect');
    }
    if (this.feedbackTween && this.feedbackTween.stop) {
      this.feedbackTween.stop();
      this.feedbackIcon.setScale(0);
    }
    this.feedbackIcon.setScale(0);
    this.feedbackIcon.x = sprite.x + this.answerGroup.x + sprite.box.width / 2;
    this.feedbackIcon.y = this.answerGroup.y - this.answerGroup.getBounds().height + sprite.box.height / 2;

    const spriteWorldPosition = sprite.getWorldTransformMatrix().transformPoint(sprite.box.x,sprite.box.y);
    this.delegate.choiceSelected(spriteWorldPosition.x + sprite.box.width / 2, spriteWorldPosition.y - sprite.box.height + 10, index === this.displayedQuestionData.answerIndex);
    this.showFeedback();
  };

  hideOtherChoices() {
    const len = this.choiceDisplays.length;
    for (let i = 0; i < len; i++) {
      if (i !== this.selectedIndex) this.choiceDisplays[i].displayText.text = '';
    }
  };

  showFeedback() {
    this.hideOtherChoices();
    this.feedbackTween = ABCyaPhaser.Tweens.addTween(this.feedbackIcon, 800, { scale: 1, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out, () => {
      this.delegate.questionFeedbackFinished();
      this.feedbackTween = null;
    });
  };

  setQuestion(questionObject) {
    this.beenAnswered = false;
    this.displayedQuestionData = questionObject;
    const choices = questionObject.choices;
    if (choices.length > this.choiceDisplays.length) {
      console.error('too many choices to display');
    }
    let len = choices.length;
    for (let i = 0; i < len; i++) {
      this.choiceDisplays[i].displayText.text = choices[i].toString();
    }
    let gridsize = null;
    let gridMax = 70;
    let iconPadding = 13;
    let textalign = 'left';
    let fontsize = 50;
    let questionY = this.txtQuestion.height + 10;
    const cnt = this.displayedQuestionData.showIcons.length;

    switch (this.displayedQuestionData.category) {

      case 'HowMany':
        questionY = this.bg.height * 0.25;
        break;

      case 'HowManyMixed':
        questionY = this.bg.height * 0.25;
        break;

      case 'HowManyBaseTen':
        gridMax = 60;
        if (cnt < 3) {
          iconPadding = 30;
        }
        else if (cnt < 6) {
          iconPadding = 25;
        }
        else if (cnt < 9) {
          iconPadding = 15;
        }
        else {
          iconPadding = 10;
        }
        questionY = this.bg.height * 0.22;
        break;
      case 'HowManyIfAdded':
        gridMax = 60;

        if (cnt < 3) {
          iconPadding = 30;
        }
        else if (cnt < 6) {
          iconPadding = 25;
        }
        else if (cnt < 9) {
          iconPadding = 15;
        }
        else {
          iconPadding = 10;
        }
        questionY = this.bg.height * 0.22;
        break;
      case 'HowManyIfSubtracted':
        questionY = this.bg.height * 0.25;
        break;
      case 'Addition':
        fontsize = 72;
        questionY = this.bg.height * 0.5;
        break;
      case 'Subtraction':
        fontsize = 72;
        questionY = this.bg.height * 0.5;
        break;

      case 'Order':
        gridsize = 100;
        questionY = this.bg.height * 0.25;
        break;

      case 'OrderNextNumber':
        gridsize = 0;
        fontsize = 72;
        questionY = this.bg.height * 0.5;
        textalign = 'center';
        break;

      case 'AdditionForX':
        gridsize = 0;
        fontsize = 72;
        questionY = this.bg.height * 0.5;
        textalign = 'center';
        break;

      case 'SubtractionForX':
        gridsize = 0;
        fontsize = 72;
        questionY = this.bg.height * 0.5;
        textalign = 'center';
        break;

      default:
    }

    this.txtQuestion.maxWidth = this.scene.scale.width;
    this.txtQuestion.align = textalign;
    this.txtQuestion.fontSize = fontsize;
    this.txtQuestion.text = questionObject.text;
    this.txtQuestion.y = questionY;

    this.showCountGroup.removeAll(true);
    this.showCountGroup.setScale(1);

    let w = 0;
    let h = 0;
    len = this.displayedQuestionData.showIcons.length;
    let totalWidth = 0;
    let maxWidth = 0;

    if (len > 0) {
      for (let i = 0; i < len; i++) {
        let sprite = this.showCountGroup.getFirst('active', false);
        if (!sprite) sprite = ABCyaPhaser.Images.addImage(0, 0, this.displayedQuestionData.showIcons[i], this.showCountGroup).setOrigin(0);

        if (!sprite) console.error('null dr');
        sprite.setFrame(this.displayedQuestionData.showIcons[i]);
        sprite.active = true;

        totalWidth += sprite.width;

        maxWidth = Math.max(sprite.width, maxWidth);

        w = sprite.width;
        h = sprite.height;
      }

      gridMax = maxWidth + 5;

      if (!gridsize) {
        gridsize = Math.max(w + iconPadding, gridMax);
      }
      Phaser.Actions.GridAlign(this.showCountGroup.getAll(), { width: -1, height: 1, cellWidth: gridsize, cellHeight: h, position: Phaser.Display.Align.CENTER });

      const bounds = this.showCountGroup.getBounds();

      if (bounds.width > this.scene.scale.width) {

        const fraction = (this.scene.scale.width - 50) / bounds.width;

        this.showCountGroup.setScale(fraction);
      }

      this.showCountGroup.x = this.scene.scale.width / 2 - this.showCountGroup.getBounds().width / 2 + gridsize / 2;
      this.showCountGroup.y = this.bg.y + (this.bg.height * 0.75) - h * 0.14;
    }
    else {
      this.showCountGroup.removeAll(true);
    }

    this.feedbackIcon.setScale(0);
  };

  doQuestionOutro() {
    this.feedbackIcon.visible = false;
    ABCyaPhaser.Tweens.addTween(this.bgContainer, 800, { y: -this.y - this.bg.height }, Phaser.Math.Easing.Quadratic.out);
  };

  getBlockPostions() {
    const locs = [];
    for (let i = 0; i < this.choiceDisplays.length; i++) {
      const spriteWorldPosition = this.choiceDisplays[i].getWorldTransformMatrix().transformPoint(this.choiceDisplays[i].box.x,this.choiceDisplays[i].box.y);
      locs.push({ x: spriteWorldPosition.x, y: spriteWorldPosition.y });
    }
    return locs;
  };

  hideBoxesAndDetach() {
    for (let i = 0; i < this.choiceDisplays.length; i++) {
      this.choiceDisplays[i].visible = false;
    }
    this.tiedToPlatform = false;
  };
}